import { IColumnsItem } from '@/components/custom-table/type.d';
import { IZoneParseListResListItem, ZONE_STATUS_ENUM } from '@/api/domain-system/type';
import { filters } from '@/core/plugins/filter';

export const renderColumns = (
  handleUpdateStatus: (row: IZoneParseListResListItem) => void,
  handleDelItem: (row: IZoneParseListResListItem[]) => void,
): IColumnsItem<IZoneParseListResListItem>[] => [
  {
    width: '50',
    type: 'selection',
  },
  {
    label: '域名',
    prop: 'zoneName',
    width: '180',
  },
  {
    label: '主机记录',
    prop: 'rr',
    width: '280',
    ellipsis: true,
  },
  {
    label: '备注',
    prop: 'remark',
    ellipsis: true,
    width: '280',
  },
  {
    label: '更新人',
    prop: 'reviserName',
    width: '180',
  },
  {
    label: '更新时间',
    width: '280',
    render: row => <div>{filters.formatTime(row.revisedTime)}</div>,
  },
  {
    label: '创建时间',
    width: '280',
    render: row => <div>{filters.formatTime(row.createdTime)}</div>,
  },
  {
    label: '状态',
    width: '100',
    render: row => (
        <el-switch
          modelValue={row.dnsState}
          active-value={ZONE_STATUS_ENUM.ENABLE}
          inactive-value={ZONE_STATUS_ENUM.DISABLE}
          onClick={() => handleUpdateStatus(row)}
        ></el-switch>
    ),
  },
  {
    label: '操作',
    width: '150',
    align: 'center',
    fixed: 'right',
    render: row => (
      <div class="flex flex-justify-center">
        <el-button
          size="default"
          type="danger"
          onClick={() => handleDelItem([row])}
        >
          删除
        </el-button>
      </div>
    ),
  },
];
